import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ApproachSection from './components/ApproachSection';

export default function HomePage() {
  useEffect(() => {
    document.title = 'HASPICA Studio de Design Bordeaux — Design Graphique & Identité Visuelle';
  }, []);

  return (
    <main>
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <ApproachSection />
      <Footer />
    </main>
  );
}
